import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

//import Components
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import RightSidebar from "../Components/Common/RightSidebar";

//import actions
import {
  changeLayout,
  changeSidebarTheme,
  changeLayoutMode,
  changeLayoutWidth,
  changeLayoutPosition,
  changeTopbarTheme,
  changeLeftsidebarSizeType,
  changeLeftsidebarViewType,
  changeSidebarImageType,
} from "../store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import ScribeHelper from "../Components/Common/ScribeHelper";
import "./layouts.styles.css";
import ClickOutside from "../Components/Common/ClickOutsideComponent";
const Layout = (props) => {
  
  const [headerClass, setHeaderClass] = useState("");
  const dispatch = useDispatch();
  const {
    layoutType,
    leftSidebarType,
    layoutModeType,
    layoutWidthType,
    layoutPositionType,
    topbarThemeType,
    leftsidbarSizeType,
    leftSidebarViewType,
    leftSidebarImageType,
  } = useSelector((state) => ({
    layoutType: state.Layout.layoutType,
    leftSidebarType: state.Layout.leftSidebarType,
    layoutModeType: state.Layout.layoutModeType,
    layoutWidthType: state.Layout.layoutWidthType,
    layoutPositionType: state.Layout.layoutPositionType,
    topbarThemeType: state.Layout.topbarThemeType,
    leftsidbarSizeType: state.Layout.leftsidbarSizeType,
    leftSidebarViewType: state.Layout.leftSidebarViewType,
    leftSidebarImageType: state.Layout.leftSidebarImageType,
  }));

  /*
    layout settings
    */
  useEffect(() => {
    if (
      layoutType ||
      leftSidebarType ||
      layoutModeType ||
      layoutWidthType ||
      layoutPositionType ||
      topbarThemeType ||
      leftsidbarSizeType ||
      leftSidebarViewType ||
      leftSidebarImageType
    ) {
      dispatch(changeLeftsidebarViewType(leftSidebarViewType));
      dispatch(changeLeftsidebarSizeType(leftsidbarSizeType));
      dispatch(changeSidebarTheme(leftSidebarType));
      dispatch(changeLayoutMode(layoutModeType));
      dispatch(changeLayoutWidth(layoutWidthType));
      dispatch(changeLayoutPosition(layoutPositionType));
      dispatch(changeTopbarTheme(topbarThemeType));
      dispatch(changeLayout(layoutType));
      dispatch(changeSidebarImageType(leftSidebarImageType));
    }
  }, [
    layoutType,
    leftSidebarType,
    layoutModeType,
    layoutWidthType,
    layoutPositionType,
    topbarThemeType,
    leftsidbarSizeType,
    leftSidebarViewType,
    leftSidebarImageType,
    dispatch,
  ]);
  /*
    call dark/light mode
    */
  const onChangeLayoutMode = (value) => {
    if (changeLayoutMode) {
      dispatch(changeLayoutMode(value));
    }
  };

  // class add remove in header
  useEffect(() => {
    const scrollNavigation = () => {
      const scrollup = document.documentElement.scrollTop;
      setHeaderClass(scrollup > 50 ? "topbar-shadow" : "");
    };
    window.addEventListener("scroll", scrollNavigation, true);
    return () => window.removeEventListener("scroll", scrollNavigation, true);
  }, []);
  const { ScribeActive } = useSelector((state) => ({
    ScribeActive: state.Scribe.scribeActive,
  }));
  const { isHeaderVisible } = useSelector((state) => ({
    isHeaderVisible: state.controlPanelReducer.isHeaderVisible,
  }));
  return (
    <React.Fragment>
      <>
        <div id="layout-wrapper">
          {isHeaderVisible && (
            <>
              <Header
                headerClass={headerClass}
                layoutModeType={layoutModeType}
                onChangeLayoutMode={onChangeLayoutMode}
              />
              <ClickOutside
                onClick={(event) => {
                  // Change #100060 - a tap on the hamburger is "outside" the
                  // menu, so this closed it on mousedown and the button's own
                  // click then toggled it straight back open: the mobile menu
                  // could never be closed with the button. The hamburger
                  // does its own toggling, so leave its taps alone.
                  if (event?.target?.closest?.("#topnav-hamburger-icon")) return;
                  document.body.classList.remove("menu");
                }}
              >
                <Sidebar layoutType={layoutType} />
              </ClickOutside>
            </>
          )}

          <div className="main-content">
            {ScribeActive ? (
              <div className={"main-content-wrapper-and-scribe-helper"}>
                <div className={ScribeActive && "main-content-with-children"}>
                  {props.children}
                </div>
                {
                  <div className={"scribe-helper-above-wrapper"}>
                    <ScribeHelper />
                  </div>
                }
              </div>
            ) : (
              <> {props.children}</>
            )}

            <Footer />
          </div>
        </div>
        <RightSidebar />
      </>
    </React.Fragment>
  );
};

Layout.propTypes = {
  children: PropTypes.object,
};

export default withRouter(Layout);
